import React, { Component } from "react";
import jwt_decode from "jwt-decode";

class SearchValidation extends Component {
  componentDidMount() {
    if (localStorage.getItem("select") !== null) {
      let value = localStorage.getItem("select").toString();
      if (value) {
        this.setSearch(value);
        this.refs.select.value = value;
      } else {
        this.setSearch("ativa");
        this.refs.select.value = "ativa";
      }
    } else {
      this.setSearch("ativa");
      this.refs.select.value = "ativa";
    }
    if (localStorage.getItem("filter") !== null) {
      let filter = localStorage.getItem("filter").toString();
      if (filter === "requester") {
        this.setFilter("requester");
        this.refs.requester.checked = true;
      } else {
        this.setFilter("requested");
        this.refs.requested.checked = true;
      }
    } else if (localStorage.getItem("token") !== null) {
      const userToken = JSON.parse(localStorage.getItem("token").toString());
      let decoded = jwt_decode(userToken.token);
      if (decoded.malote_escrever === 1) {
        this.setFilter("requester");
        this.refs.requester.checked = true;
      } else {
        this.setFilter("requested");
        this.refs.requested.checked = true;
      }
    } else {
      this.setFilter("requester");
      this.refs.requester.checked = true;
    }
  }

  setSearch = value => {
    localStorage.setItem("select", value);
    this.props.handleFilter(
      localStorage.getItem("filter") !== null
        ? localStorage.getItem("filter").toString()
        : "requester"
    );
    this.props.handleSearch(
      localStorage.getItem("select") !== null
        ? localStorage.getItem("select").toString()
        : "ativa"
    );
  };

  setFilter = filter => {
    this.props.handleFilter(filter);
    this.props.handleSearch(
      localStorage.getItem("select") !== null
        ? localStorage.getItem("select").toString()
        : "ativa"
    );
    if (filter === "requester") {
      this.refs.select.value =
        localStorage.getItem("select") !== null
          ? localStorage.getItem("select").toString()
          : "ativa";
      this.refs.requester.checked = true;
      this.refs.requested.checked = false;
    } else if (filter === "requested") {
      this.refs.select.value =
        localStorage.getItem("select") !== null
          ? localStorage.getItem("select").toString()
          : "ativa";
      this.refs.requested.checked = true;
      this.refs.requester.checked = false;
    }
    localStorage.setItem("filter", filter);
  };

  render() {
    return (
      <React.Fragment>
        <div
          className="container"
          style={{
            position: "relative"
          }}
        >
          <div
            className="row justify-content-center"
            style={{ paddingTop: "25px" }}
          >
            <div className="col-12">
              <form
                className="box-search-validation"
                style={{
                  backgroundColor: "none",
                  boxShadow:
                    "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)"
                }}
              >
                <center>
                  <div className="row">
                    <div className="col s12">
                      <label
                        id="description"
                        className="center"
                        htmlFor="checkbox"
                        align="center"
                        style={{ marginTop: "5px", marginBottom: "35px" }}
                      >
                        &nbsp;Selecione o perfil desejado:
                      </label>
                      <div className="filters-validation">
                        <span style={{ padding: "10px" }}>
                          <input
                            ref="requester"
                            type="checkbox"
                            defaultValue="requester"
                            id="requester"
                            name="requester"
                            autoFocus
                            onChange={e => this.setFilter(e.target.value)}
                          />
                          <label htmlFor="requester">Remetente</label>
                        </span>
                        <span>
                          <input
                            ref="requested"
                            type="checkbox"
                            defaultValue="requested"
                            id="requested"
                            name="requested"
                            onChange={e => this.setFilter(e.target.value)}
                          />
                          <label htmlFor="requested">Destinatário</label>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: "-15px" }}>
                    <div className="col s6">
                      <label
                        id="select"
                        className="center"
                        htmlFor="select"
                        align="center"
                      >
                        &nbsp;Selecione o <i>status</i> do malote desejado:
                      </label>
                      <select
                        className="form-control"
                        ref="select"
                        align="center"
                        required
                        id="select"
                        onChange={e => this.setSearch(e.target.value)}
                        defaultValue="-1"
                        style={{
                          width: "50%",
                          display: "block",
                          marginTop: "-5px",
                          marginBottom: "10px"
                        }}
                      >
                        <option value="-1" disabled>
                          Status...
                        </option>
                        <option value="ativa">ATIVO</option>
                        <option value="pendente">PENDENTE</option>
                        <option value="concluida">CONCLUÍDO</option>
                      </select>
                    </div>
                  </div>
                </center>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SearchValidation;
